module.exports = __webpack_public_path__ + "img/79.e70d70b3.jpg";